import { render, staticRenderFns } from "./FinancialFreedom.vue?vue&type=template&id=b51f348e&scoped=true&"
import script from "./FinancialFreedom.vue?vue&type=script&lang=js&"
export * from "./FinancialFreedom.vue?vue&type=script&lang=js&"
import style0 from "./FinancialFreedom.vue?vue&type=style&index=0&id=b51f348e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51f348e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
